// SearchComp.js
import { Input } from "antd";
import { SearchOutline } from "themes/Icon";

function SearchComp({
  height = 48,
  className,
  placeholder,
  suffix,
  large = true,
  border = true,
  bgNone,
  type = "text",
  value,
  onChange,
}) {
  return (
    <Input
      className={`search-comp ${large ? "large-search" : "small-search"} ${
        border ? "search-border" : ""
      } ${bgNone ? "bg-none" : ""} ${className}`}
      prefix={<SearchOutline />}
      suffix={suffix}
      style={{ height: `${height}px` }}
      placeholder={placeholder}
      value={value}
      type={type}
      onChange={onChange}
    />
  );
}

export default SearchComp;
